import React from 'react';
import { Badge } from 'reactstrap';
import { ViewButton } from '../../Common/DataTable/tableActionButtons';
import { getFilter, getSort } from '../../Common/DataTable/tableHelpers';
import moment from 'moment';

const createTableColumns = (openViewModal, users) => [
  {
    title: 'Affiliate ID',
    name: 'affiliateId',
    width: 120,
    formatterComponent: ({ value }) => (
      <span className="text-muted">{value}</span>
    ),
  },
  {
    title: 'Utente',
    name: 'userId',
    width: 120,
    getCellValue: (row) => {
      const user = users.find((user) => user.id === row.userId);
      return user?.email || 'N/A';
    },
  },
  {
    title: 'Utente',
    name: 'userEmail',
    width: 180,
    formatterComponent: ({ value }) => (
      <span className="text-muted">{value}</span>
    ),
  },
  {
    title: 'Piano',
    name: 'plan',
    width: 120,
    formatterComponent: ({ value }) => (
      <Badge color={value === 'monthly' ? 'primary' : 'success'}>
        {value === 'monthly' ? 'Mensile' : 'Semestrale'}
      </Badge>
    ),
  },
  {
    title: 'Importo Sottoscrizione',
    name: 'subscriptionAmount',
    width: 150,
    formatterComponent: ({ value }) => `€ ${value.toFixed(2)}`,
  },
  {
    title: 'Commissione',
    name: 'amount',
    width: 120,
    formatterComponent: ({ value }) => (
      <strong className="text-success">€ {value.toFixed(2)}</strong>
    ),
  },
  {
    title: 'Valuta',
    name: 'currency',
    width: 80,
    formatterComponent: ({ value }) => value || 'EUR',
  },
  {
    title: 'Sorgente',
    name: 'source',
    width: 100,
    formatterComponent: ({ value }) => (
      <span className="text-muted">{value}</span>
    ),
  },
  {
    title: 'Campagna',
    name: 'campaign',
    width: 100,
    formatterComponent: ({ value }) => (
      <span className="text-muted">{value}</span>
    ),
  },
  {
    title: 'Created At',
    name: 'createdAt',
    width: 120,
    formatterComponent: ({ value }) => `${moment(value).fromNow()}`,
    sorting: (a, b) => getSort(moment(a).valueOf(), moment(b).valueOf()),
    filter: (value, filter) =>
      getFilter(`${moment(value).fromNow()}`, filter.value),
  },
  {
    title: 'Actions',
    name: 'action',
    width: 160,
    align: 'center',
    formatterComponent: ({ row }) => (
      <ul className="list-inline font-size-20 contact-links mb-0">
        {openViewModal && <ViewButton row={row} onPress={openViewModal} />}
      </ul>
    ),
    filter: 'disabled',
    sorting: 'disabled',
  },
];

export default createTableColumns;
